import { Checkbox, CheckboxGroup, Stack } from "@chakra-ui/react";

// Cases à cocher des sites d'un forfait ou d'une intervention
export default function SitesCheckboxes(props: {
  sites: SiteType[];
  value: string[];
  onChange: (ids: string[]) => void;
}) {
  return (
    <CheckboxGroup value={props.value} onChange={(ids) => props.onChange(ids as string[])}>
      <Stack spacing={1}>
        {props.sites.map((site) => (
          <Checkbox key={site.id} value={site.id}>
            {site.nom}
            {!site.actif && " (archivé)"}
          </Checkbox>
        ))}
      </Stack>
    </CheckboxGroup>
  );
}
